import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataRequest, fetchDataSuccess } from "../../../core/redux/action";
import { Configurations } from "../../../services/internal/configurations";
import FormEmailConf from '../../components/emailConfForm'
import ToolsHead from '../../components/toolsHead'
import { Mail } from 'react-feather'
import { showSuccessAlert } from "../../components/customAlert";
import { Spinner } from "react-bootstrap";
import { Switch } from "antd";
import TokenRefresh from "../../../Router/tokenRefresh";

const EmailSettings = () => {

    const loading = useSelector((state) => state.loading);
    const token = useSelector(state => state.token);
    const dispatch = useDispatch();
    const [emailConf, setEmailConf] = useState({});
    const tokenRefreshRef = useRef(null);
    const abortController = new AbortController();

    const onLoadConfiguration = async () => {
        try {
            dispatch(fetchDataRequest());
            const response = await Configurations.getList(token, { name: "Email" }, abortController);
            setEmailConf(JSON.parse(response.data.data[0]?.value));

            dispatch(fetchDataSuccess(response.data.success));
        }
        catch (err) {
            if (tokenRefreshRef.current) {
                tokenRefreshRef.current.handleException(err);
            }
        }
    }

    const fakeBackendCall = async (delay = 2000) => {

        return new Promise((resolve) => {
            dispatch(fetchDataRequest());
            setTimeout(() => {
                resolve("Respuesta del backend");
                dispatch(fetchDataSuccess(true));
                showSuccessAlert("Hemos enviado el correo");
            }, delay);
        });
    };

    useEffect(() => {
        onLoadConfiguration();
    }, [token]);

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4>Configuración de Email</h4>
                            <h6>Puedes visualizar la configuración que usa el sistema para el envío de notificaciones por correo electrónico.</h6>
                        </div>
                    </div>
                    <ToolsHead
                        onReload={onLoadConfiguration}
                    />
                    <div className="page-btn">
                        <a
                            className="btn btn-added"
                            onClick={async () => { await fakeBackendCall(); }}
                        >
                            {loading ? <Spinner size="sm" /> :
                                <span>
                                    <Mail className="me-2" />
                                    Enviar correo de prueba
                                </span>
                            }
                        </a>
                    </div>
                </div>
                <div className="connected-app-card email-setting d-flex w-100">
                    <ul className="w-100">
                        <li className="flex-column align-items-start">
                            <div className="d-flex align-items-center justify-content-between w-100 mb-2">
                                <div className="security-type d-flex align-items-center">
                                    <div className="security-title">
                                        <h5>GoDaddy</h5>
                                    </div>
                                </div>
                                <div className="connect-btn">
                                    <a>Conectado</a>
                                </div>
                            </div>
                            <p>
                                El servicio de correo de GoDaddy es una solución de correo electrónico profesional diseñada para empresas y usuarios individuales que buscan direcciones de correo personalizadas basadas en su dominio.
                            </p>
                        </li>
                        <li>
                            <Switch
                                checked
                                disabled
                            />
                        </li>
                    </ul>
                </div>
                <div className="card p-4">
                    {emailConf && <FormEmailConf settings={emailConf} />}
                </div>
            </div>
            <TokenRefresh ref={tokenRefreshRef} />
        </div>
    )
}

export default EmailSettings
